import Vue from 'vue';
import VueImg from 'v-img';
 
Vue.use(VueImg);


// WEBPACK FOOTER //
// ./resources/assets/js/plugins/vImg.js